export default {
  overlay: {
    position: null,
    top: null,
    left: null,
    right: null,
    bottom: null,
    backgroundColor: null
  },
  content: {
    position: null,
    top: null,
    left: null,
    right: null,
    bottom: null,
    border: 'none',
    background: 'none',
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
    borderRadius: '0',
    outline: 'none',
    padding: '0'
  }
}
